import Flickity from 'flickity';
import { RouteHandler } from '@whitetail/buckshot/scripts/buckshot-routes';
import $ from '@whitetail/buckshot/scripts/buckshot-dom';
import { arrow } from '../../scripts/flickityOptions';

class ImageSlider {
    constructor($el) {
        this.$slider = $el;
        this.flickity = null;
    }

    initSlider() {
        let config = {
            arrowShape: arrow,
        };

        if (this.$slider.data('autoplay')) {
            config = {
                arrowShape: arrow,
                autoPlay: 6000,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
            };
        }

        this.flickity = new Flickity(this.$slider[0], config);
    }
}

export default new RouteHandler({
    init() {
        const imageSlider = new ImageSlider($(':imageSlider'));

        imageSlider.initSlider();
    },
});
